export function questionnaireScript() {

    $(document).ready(function() {
        $('#questionnaire_type_1').on('click', function () {
            if (this.checked) {
                $('.questionnaire__full').fadeOut( "fast", "linear" );
            }
        });
        $('#questionnaire_type_2').on('click', function () {
            if (this.checked) {
                $('.questionnaire__full').fadeIn( "fast", "linear" );
            }
        });
        $('#discount_system_1').on('click', function () {
            if (this.checked) {
                $('.discount_system_description').fadeIn( "fast", "linear" );
                $('.standard_bonus_systems').fadeIn( "fast", "linear" );
            }
        });
        $('#discount_system_2').on('click', function () {
            if (this.checked) {
                $('.discount_system_description').fadeOut( "fast", "linear" );
                $('.standard_bonus_systems').fadeOut( "fast", "linear" );
            }
        });
        $('#input_name').on('blur', function (e) {
            var str = $(this).val();
            str.replace(/ +/g, ' ').trim();
            $(this).val(str.replace(/ +/g, ' ').trim());
        });
        $('#input_contacts').on('blur', function (e) {
            var str = $(this).val();
            str.replace(/ +/g, ' ').trim();
            $(this).val(str.replace(/ +/g, ' ').trim());
        });
        $('#input_company_name').on('blur', function (e) {
            var str = $(this).val();
            str.replace(/ +/g, ' ').trim();
            $(this).val(str.replace(/ +/g, ' ').trim());
        });

    });

}


// WEBPACK FOOTER //
// ./private/blocks/questionnaire/questionnaire.js